<template>
  <div class="nx-list-page">
    <dialog-reset v-loading="loading" slotShow height="65vh" width="1150px" top="10vh" title="到达详情"
      :visible.sync="show">
      <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page"
        :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
        @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange"
        :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange">
      </avue-crud>
    </dialog-reset>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
        menu: false,
        column: [
          {
            label: '车厢编号',
            prop: 'carriageNumber',
          },
          {
            label: '车厢序号',
            prop: 'carriageSerial',
          },
          {
            label: '车型',
            prop: 'carriageType',
          },
          {
            label: '车厢数',
            prop: 'carriageCount',
          },
          {
           label: '煤种',
            prop: 'cargoName',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            props: {
              label: 'cargoName',
              value: 'id'
            },
          },
          {
            label: '总重量(吨)',
            prop: 'totalWeight',
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
      show: false
    }
  },
  methods: {
    open(id) {
      this.show = true
      this.defaultParams = {
        extId: id
      }
      this.$nextTick(() => {
        this.searchReset()
      })
    }
  }
}
</script>
<style scoped lang="scss"></style>
